export default __webpack_public_path__ + "static/media/pic7.0034011e.jpg";